import {
  actionAddCustomAmenity,
} from '~/legacy/store';

/* eslint-disable */
export const doInit = ({ data: { refresh, access } }) => {};
/* eslint-enable */

export const refreshAfterDeleteListing = ({ actions }) => {
  actions.getMyListings();
};

export const addCustomAmenities = ({
  getState,
  dispatch,
  data: { amenities },
}) => {
  const {
    api: {
      init: {
        data: { amenities: existingAmenities },
      },
    },
  } = getState();
  if (!amenities) {
    // eslint-disable-next-line
    amenities = [];
  }
  amenities.forEach((a) => {
    if (!existingAmenities.find((ea) => ea.name === a)) {
      dispatch(actionAddCustomAmenity(a));
    }
  });
};
